<template>
    <mdb-container>
        <Vedheader></Vedheader>
        <mdb-alert color="danger" v-if="error" class="mt-3">
            {{ error }}
        </mdb-alert>
        <mdb-alert color="success" v-if="success" class="mt-3">
            {{ success }}
        </mdb-alert>
        <mdb-alert color="info" v-if="this.$store.state.mustcompleteprofile" class="mt-3">
            Veuillez compléter les informations de votre profil pour continuer
        </mdb-alert>
        <mdb-card class="card-body" style="margin-top: 1rem;" v-if="isLoading">
            <div class="d-flex justify-content-center">
                <mdb-spinner big color="blue" />
            </div>
        </mdb-card>
        <mdb-row v-if="!isLoading">
            <mdb-col>
                <mdb-card class="mt-5" cascade narrow>
                    <mdb-card-header cascade class="text-center">
                        <h5 class="mb-0 font-weight-bold">Mon profil</h5>
                    </mdb-card-header>
                    <mdb-card-body cascade>
                        <mdb-row v-if="needccv">
                            <mdb-col md="4">
                                <mdb-input label="CCV" v-model="userinfos.ccv" small="Si vous n'êtes pas un conseiller en voyage et voulez avoir accès à cette plateforme, veuillez nous contacter à l'adresse aide@voyagesendirect.com" >
                                    <mdb-btn color="primary" size="md" group slot="append" id="button-addon2" v-on:click="validateCcv" v-on:change="ccvvalidated = false">Valider</mdb-btn>
                                </mdb-input>
                            </mdb-col>
                        </mdb-row>
                        <mdb-row>
                            <mdb-col md="4">
                                <mdb-input label="Prénom" v-model="userinfos.firstname" :disabled="needccv" :style="needccv?'background-color: #eee;':''" />
                            </mdb-col>
                            <mdb-col md="4">
                                <mdb-input label="Nom de famille" v-model="userinfos.lastname" :disabled="needccv" :style="needccv?'background-color: #eee;':''" />
                            </mdb-col>

                        </mdb-row>
                        <mdb-row>
                            <mdb-col md="4">
                                <mdb-input label="Adresse courriel" v-model="userinfos.email" />
                            </mdb-col>
                            <mdb-col md="4">
                                <mdb-input label="Téléphone" v-model="userinfos.phone" />
                            </mdb-col>
                        </mdb-row>
                        <mdb-row>
                            <mdb-col md="4">
                                <mdb-input label="Adresse postale" v-model="userinfos.address" />
                            </mdb-col>
                            <mdb-col md="4">
                                <mdb-input label="Ville" v-model="userinfos.city" />
                            </mdb-col>
                            <mdb-col md="4">
                                <mdb-input label="Code postal" v-model="userinfos.postalcode" />
                            </mdb-col>
                        </mdb-row>
                        <mdb-row>
                            <mdb-col md="4">
                                <mdb-input label="Agence" v-model="userinfos.agency" :disabled="needccv" :style="needccv?'background-color: #eee;':''" />
                            </mdb-col>

                        </mdb-row>
                        <mdb-row>
                            <mdb-col md="4">
                                <mdb-input label="Nouveau mot de passe" v-model="newpassword" type="password" />
                            </mdb-col>
                        </mdb-row>

                        <div class="text-left">
                            <mdb-btn v-on:click="updateuser">Enregistrer</mdb-btn>
                        </div>
                    </mdb-card-body>
                </mdb-card>
            </mdb-col>
        </mdb-row>
    </mdb-container>
</template>

<script>
    import Vedheader from '@/components/Header.vue';
    import {
        mdbContainer,
        mdbAlert,
        mdbSpinner,
        mdbCard,
        mdbRow,
        mdbCol,
        mdbCardHeader,
        mdbCardBody,
        mdbInput,
        mdbBtn,
    } from 'mdbvue';
    import Apicall from '../libs/Apicall';

    export default {
        name: 'Home',
        components: {
            Vedheader,
            mdbContainer,
            mdbAlert,
            mdbSpinner,
            mdbCard,
            mdbRow,
            mdbCol,
            mdbCardHeader,
            mdbCardBody,
            mdbInput,
            mdbBtn,
        },
        data() {
            return {
                videos: '',
                error: '',
                isLoading: false,
                needccv: false,
                userinfos: {
                    firstname: '',
                    lastname: '',
                    ccv: '',
                    email: '',
                    phone: '',
                    address: '',
                    city: '',
                    postalcode: '',
                    agency: '',
                },
                newpassword: '',
                success: '',
                ccvvalidated: false,
            };
        },
        mounted() {
             this.getAndDisplayMyInfos();
        },
        methods: {
            getAndDisplayMyInfos() {
                const api = new Apicall();
                const self = this;
                api.getMyInfos().then((response) => {
                    if (response.data.status === 'OK') {
                        self.needccv = response.data.needccv;
                        self.userinfos = response.data.userinfos;
                        if ((self.userinfos.ccv === '' || self.userinfos.ccv === null) && self.needccv) {
                            self.ccvvalidated = false;
                        } else {
                            self.ccvvalidated = true;
                        }
                    } else {
                        self.error = response.msg;
                    }
                    self.isLoading = false;
                });
            },

            validateCcv() {
                const api = new Apicall();
                const self = this;
                this.isLoading = true;
                api.validateCcv(this.userinfos.ccv).then((response) => {
                    this.isLoading = false;
                    if (response.status === 'OK') {
                        self.ccvvalidated = true;
                        self.userinfos.firstname = response.firstname;
                        self.userinfos.lastname = response.lastname;
                        self.userinfos.agency = response.agencyname;
                        self.error = '';
                    } else {
                        self.error = response.msg;
                        window.scrollTo(0, 0);
                    }
                    self.isLoading = false;
                });
            },

            updateuser() {
                const api = new Apicall();
                const self = this;
                if (!this.ccvvalidated) {
                    self.error = 'Veuillez valider votre CCV avant de sauvegarder vos informations';
                    window.scrollTo(0, 0);
                } else {
                    api.udpateMyProfile(this.userinfos, this.newpassword).then((response) => {
                        if (response.status === 'OK') {
                            self.success = 'vos informations ont été mises à jour';
                            self.error = '';
                            if (self.$store.state.mustcompleteprofile) {
                                self.$store.state.mustcompleteprofile = false;
                                self.$router.push({ path: '/' });
                            }
                            self.$store.state.mustcompleteprofile = false;
                        } else {
                            self.error = response.msg;
                        }
                        window.scrollTo(0, 0);
                        self.isLoading = false;
                    });
                }
            },
        },
    };
</script>
